/**
 * Hebrew strings for סיכום הזמנה — merged under successorder after fetch.
 * Ensures new keys resolve even when /locales/he.json is served from an HTTP cache.
 */
export const successorderHeFallback = {
  ordernumber: "מספר הזמנה",
  flightdates: "תאריכי טיסה",
  passengers: "נוסעים",
  infants: "תינוקות",
  banktransfer: "העברה בנקאית",
  onlinepayment: "תשלום מקוון",
  awaitingpayment: "ממתין לתשלום",
  downloadorder: "הורדת הזמנה",
  downloaditinerary: "הורדת ITINERARY",
  downloadvoucher: "להורדת השובר",
  baggage: "כבודה",
  baggageEmpty: "לא נוספה כבודה",
};
